<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
// Dependencies
import { mapGetters } from 'vuex'
import config from '@config/app.json'

// Export
export default {
	name: 'app',
	computed: {
		...mapGetters([
			'site',
		]),
	},
	metaInfo() {
		return {
			title: `${this.site.name || 'Trunk'}`,
			titleTemplate: '%s | CMS',
			meta: [
				{
					charset: 'utf-8',
				},
				{
					'http-equiv': 'X-UA-Compatible',
					content: 'IE=edge',
				},
				{
					name: 'description',
					content: 'Trunk CMS - A GraphQL Powered Headless CMS',
				},
				{
					name: 'viewport',
					content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui',
				},
			],
			link: [
				{
					rel: 'icon',
					href: require('@/assets/images/trunk-cms_icon.png'),
					type: 'image/png',
				},
				{
					rel: 'apple-touch-icon',
					href: require('@/assets/images/trunk-cms_icon.png'),
					type: 'image/png',
				},
				{
					rel: 'stylesheet',
					href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500|Nunito+Sans:300,400,600,700,800,900|Lato|Material+Icons',
					type: 'text/css',
				},
			],
			script: [
				{
					type: 'text/javascript',
					// async: true,
					// defer: true,
					src: `https://maps.googleapis.com/maps/api/js?key=${config.google.apiKey}`,
				},
			],
		}
	},
}
</script>

<style lang="scss">
	@import './styles/main';

	#app {
		background-color: white;
		display: flex;
		flex-direction: column;
		flex: 1;
		min-height: 100%;
		width: 100%;
	}

	.transition {
		&--fade {
			&-enter-active {
				animation: fadeIn 250ms $easing-material;
			}

			&-leave-active {
				animation: fadeOut 250ms $easing-material;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue